module.exports = __webpack_public_path__ + "static/slider1-min-b6f1ef75f92575d7880e12eb349935b5.jpg";